module.exports = __webpack_public_path__ + "static/logo-dbb577fa5d6edebbb7d8edd07e808288.svg";